import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom'; 
import App from './App';

const renderComponentByClassName = (className, Component) => {
    const elements = document.getElementsByClassName(className);
  
    if (elements.length > 0) {
      const element = elements[0];
      const root = ReactDOM.createRoot(element);
  
      root.render(
        <HashRouter>
          <Component />
        </HashRouter>
      );
    } else {
      console.error(`Element with class name ${className} not found`);
    }
  };
  
  // Render the `ImportPage` component dynamically with routing
  renderComponentByClassName('smscorecardwidget',App );
  
